// src/merch/preview.js — small "what it looks like" images of a design:
// the artwork on the product colour, clipped to the sticker shape.
// Used for order previews (review queue, Stripe) and the design email.

import { stickerPath2D } from "./shapes";
import { BLEED_MM, getProduct, getSize, getSides, getColour, printAreaFor, printSizeFor } from "./products";
import { merch, layersForSide } from "./store";
import { buildPrintCanvas } from "./usePrintComposite";

/** Review/Stripe preview: artwork on the product colour, clipped to the sticker. */
export function previewPng(printCanvas, colourHex, sticker, width = 900) {
  const h = Math.round((printCanvas.height / printCanvas.width) * width);
  const c = document.createElement("canvas");
  c.width = width;
  c.height = h;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, h);
  // trim box inside the bleed
  const bx = (BLEED_MM / (sticker.widthMm + BLEED_MM * 2)) * width;
  const by = (BLEED_MM / (sticker.heightMm + BLEED_MM * 2)) * h;
  const tw = width - bx * 2, th = h - by * 2;
  const shape = stickerPath2D(sticker, bx, by, tw, th);
  ctx.save();
  ctx.clip(shape);
  ctx.fillStyle = colourHex;
  ctx.fillRect(0, 0, width, h);
  ctx.drawImage(printCanvas, 0, 0, width, h);
  ctx.restore();
  ctx.strokeStyle = "rgba(0,0,0,0.25)";
  ctx.lineWidth = 2;
  ctx.stroke(shape);
  return new Promise((res) => c.toBlob(res, "image/png"));
}


/** Preview PNG of the current design's first designed side (front first). */
export async function designPreview(width = 600) {
  const product = getProduct(merch.productId);
  const size = getSize(product, merch.sizeId);
  const colour = getColour(product, merch.colourId);
  const zones = getSides(product, size, merch.hand);
  const z = zones.find((x) => layersForSide(x.id).length);
  if (!z) return null;
  const st = z.sticker;
  const canvas = await buildPrintCanvas(printAreaFor(st), st, BLEED_MM, Math.min(1536, printSizeFor(st)), z.id);
  return previewPng(canvas, colour.hex, st, st.widthMm / st.heightMm > 6 ? 1000 : width);
}
